<script setup lang="ts">
import TrademarkCard from '@/components/mark-view/trademark-card.vue';
import ProductCard from '@/components/goods-view/product-card.vue';
import OwnerCard from '@/components/contact-view/owner-card.vue';
import { useRouter } from 'vue-router';
import RouteName from '@/router/route-name';
import TermsCard from '@/components/terms-and-condition/TermsCard.vue';
import {useApplicationStore} from '@/store/application';
import { useAnalytics } from '@/composables/useAnalytics';
import { storeToRefs } from 'pinia';
import { useOwnerStore } from '@/store/owner';
import { useNotification } from '@/composables/useNotification';
import { useProductStore } from '@/store/good';
import { useTrademarkStore } from '@/store/mark';
import { useTermOfUseStore } from '@/store/terms-of-use';
import useMobile from '@/composables/useMobileDependable';

const router = useRouter();
const { showInfoNotification } = useNotification();
const applicationStore = useApplicationStore();
const ownerStore = useOwnerStore();
const productStore = useProductStore();
const trademarkStore = useTrademarkStore();
const termsStore = useTermOfUseStore();
const analytics = useAnalytics();
const { isMobile } = useMobile();
const { mobileNumber, email } = storeToRefs(useOwnerStore());


const SubmitApplication = () => {
    const applicationValid = applicationStore.validateApplication()
    if (!applicationValid) {
        let message = '<b>It looks like we’re missing some information.</b>';
        const errorMessages = []
        if (!trademarkStore.isTrademarkStepValid) {
            errorMessages.push('You need to add your trademark.');
        }
        if (!productStore.isProductStepValid) {
            errorMessages.push('You need to select your products and services.');
        }
        if (!ownerStore.isOwnerStepValid) {
            errorMessages.push('You need to complete owner details.');
        }
        if (!termsStore.isTermOfUseStepValid) {
            errorMessages.push('You need to check the confirmation box.');
        }

        if (isMobile.value) {
            message +=  '<br>' + errorMessages.join('<br>');
        } else {
            message +=  ' ' + errorMessages.join(' ');
        }

        showInfoNotification(message, 'error');
        return;
    }

    analytics.sendEvent('contact', {
        email: email.value,
        phone: mobileNumber.value,
    });

    router.push({name: RouteName.PAYMENT});
}
</script>

<template>
    <trademark-card class="my-3"/>
    <product-card  class="my-3"/>
    <owner-card  class="my-3"/>
    <terms-card  class="my-3"/>
    <StfButton @click="SubmitApplication" style="height: 50px;">CONFIRM AND PAY</StfButton>
</template>

<style scoped>

</style>
